import React, { } from 'react';
import { Tabs } from 'antd';
import { Route, Switch, withRouter } from 'react-router-dom';
import PowerBiDashboard from './powerBiDashboard';
import ClaimsList from './ClaimsList';
import ClaimDetails from './ClaimDetails';
import TabPane from 'antd/es/tabs/TabPane';
import { useDispatch } from 'react-redux';
import { setDashboardFilter } from '../../store/actions/dashboardAction';
import { DASHBOARD_TABS } from '../../shared/constants/tabConstants';

function Dashboard({ match: { params: { dashboardId } } }: any) {
    const dispatch = useDispatch();
    const data: any = localStorage.getItem('data');
    const jsonData = data?.length > 0 ? JSON.parse(data) : {};
    const isABHI = jsonData?.providerDetail?.providerId === 516571;
    const isMATPA = jsonData?.providerDetail?.providerId === 516572;
    const isHDFC = jsonData?.providerDetail?.providerId === 523844;
    const isRGI = jsonData?.providerDetail?.providerId === 523850;
    const isICICI = jsonData?.providerDetail?.providerId === 531038;
    const isMDI = jsonData?.providerDetail?.providerId === 522771;
    const isStarDirect = jsonData?.providerDetail?.providerId === 536743;

    let loggedInPayerName = '';
    if (isABHI) {
        loggedInPayerName = 'ABHI';
    } else if (isMATPA) {
        loggedInPayerName = 'MATPA';
    } else if (isHDFC) {
        loggedInPayerName = 'HDFC';
    } else if (isRGI) {
        loggedInPayerName = 'RGI';
    } else if (isICICI) {
        loggedInPayerName = 'ICICI';
    } else if (isMDI) {
        loggedInPayerName = 'MDI';
    } else if (isStarDirect) {
        loggedInPayerName = 'StarDirect';
    }

    const onTabChange = (key: string): void => {
        const currentTab = DASHBOARD_TABS?.filter((tab: any): any => tab?.key === key);
        dispatch(setDashboardFilter({}, currentTab[0]?.dashboardType || ''));
    }

    return (
        <>
            {/* Routing changes to route to claim details page  */}
            <Switch>
                <Route path="/dashboard/claimsDetails/" component={ClaimDetails} />
                <Route path='/dashboard'>
                    <Tabs
                        defaultActiveKey={'dashboard-360'} className="ml-3" onChange={onTabChange}>
                        {
                            DASHBOARD_TABS?.filter((tab: any): any => tab?.requiredFor?.includes(loggedInPayerName))?.map((tab: any): any => {
                                return (
                                    <TabPane key={tab?.key} tab={tab?.name}>
                                        <PowerBiDashboard dashboardType={tab?.dashboardType} table={tab?.tableName} column={tab?.columnName} filterColumnName={tab?.filterColumnName} timePeriodFilterRequired={tab?.timePeriodFilterRequired} filterTableName={tab?.filterTableName} hideFooterTabs={tab?.hideFooterTabs} />
                                    </TabPane>
                                );
                            })
                        }
                        {
                            process.env.REACT_APP_SHOW_CLAIM_LIST === 'true' &&
                            <TabPane key='claims-list' tab='Claims List'>
                                <ClaimsList />
                            </TabPane>
                        }
                    </Tabs>
                </Route>
            </Switch>
        </>
    );
}

export default withRouter(Dashboard);
